import { performGetRequest, performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	TemplateForm,
	FormQuestions,
} from '@atlassian/proforma-common-core/form-system-models';

export const getForm = async (cloudId: string, projectId: number, formId: number) =>
	performGetRequest<TemplateForm>(
		`/gateway/api/proforma/cloudid/${cloudId}/api/2/projects/${projectId}/forms/${formId}`,
	);

export const updateForm = async (
	cloudId: string,
	projectId: number,
	formId: number,
	form: TemplateForm,
) =>
	performPutRequest(
		`/gateway/api/proforma/cloudid/${cloudId}/api/2/projects/${projectId}/forms/${formId}`,
		{
			body: JSON.stringify(form),
		},
	);

export const removeLinkedFields = async (
	cloudId: string,
	projectId: number,
	formId: number,
	duplicateJiraFieldsInForm: string[],
) => {
	const form = await getForm(cloudId, projectId, formId);

	const updatedForm = removeDuplicateFieldsFromForm(form, duplicateJiraFieldsInForm);

	await updateForm(cloudId, projectId, formId, updatedForm);
};

export const removeDuplicateFieldsFromForm = (
	form: TemplateForm,
	duplicateJiraFieldsInForm: string[],
): TemplateForm => {
	const updatedQuestions = Object.keys(form.design.questions).reduce<FormQuestions>(
		(acc, questionKey) => {
			const question = form.design.questions[questionKey];

			if (question.jiraField && duplicateJiraFieldsInForm.includes(question.jiraField)) {
				acc[questionKey] = {
					...question,
					jiraField: undefined,
				};
			} else {
				acc[questionKey] = question;
			}

			return acc;
		},
		{},
	);

	return {
		...form,
		design: {
			...form.design,
			questions: {
				...updatedQuestions,
			},
		},
	};
};
